import { combineEpics } from 'redux-observable'
import { Epic } from 'interfaces/middleware'
import { of } from 'rxjs'
import { setNavigationTrackingActionCreator } from 'actions/navigationActions'

const TRACKING_STORAGE_KEY = 'tracking'

const trackingEpic: Epic = () => {
  /**
   * Tracking information should be persistent across state and epics remount thus sessionStorage is used.
   */
  let search = window.sessionStorage.getItem(TRACKING_STORAGE_KEY)
  if (search === null) {
    search = window.location.search
    if (search) {
      window.sessionStorage.setItem(TRACKING_STORAGE_KEY, search)
    }
  }

  return of(setNavigationTrackingActionCreator(search))
}

export default combineEpics(
  trackingEpic,
)
